import {
  INCIDENT_ATTACHMENT_EXTENSIONS,
  INCIDENT_ATTACHMENT_MIMES,
  toAcceptList,
} from '@/hooks/useUpload/fileTypeLists'

export const FILE_TYPES = INCIDENT_ATTACHMENT_EXTENSIONS
export const ALLOWED_EXTENSIONS = toAcceptList(FILE_TYPES)
export const ALLOWED_MIME_TYPES = INCIDENT_ATTACHMENT_MIMES

export const BYTES_IN_MB = 1048576
export const MAX_FILES = 4
export const MAX_FILENAME_LENGTH = 255
export const MAX_FILE_SIZE = 524288000 // 500 MB
